import React, { useState } from 'react'
import { CircularProgress } from '@maas-components/core'
import SearchIcon from '@material-ui/icons/Search'
import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import { youtubeParser } from 'core/common/utils/regex'
import { Button, Box, Grid, OutlinedAddon, OutlinedAdornment } from 'core/components/Core/index'
import TextField from 'core/components/TextField/index'
import Typography from 'core/components/Typography/index'
import ProductVideoModal from './ProductVideoModal'
import Video from './Video/index'

const ProductVideo = ({ noDeleteDialog, onVideoLoad, onVideoError }) => {
  const { setFieldValue, values } = useFormikContext()

  const [isVideoValid, setIsVideoValid] = useState(false)
  const [loadingVideo, setLoadingVideo] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const videoLink = values.searchVideo

  const searchVideo = () => {
    setLoadingVideo(true)
    setIsModalOpen(true)
  }

  const handleChange = event => {
    setIsVideoValid(youtubeParser(event.target.value) !== null)
    setFieldValue('searchVideo', event.target.value)
  }

  const hasVideoError = !!videoLink && !isVideoValid

  if (hasVideoError && onVideoError) {
    onVideoError()
  }

  return (
    <Box pt={4} px={4}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography fontSize="medium" fontWeight="medium">
            {i18n.t('product.video')}
          </Typography>
          <Typography mb={2} fontSize="small">
            {i18n.t('product.productUpload.videoLinkSubtitle')}
          </Typography>
          {values.video ? (
            <Video
              videoLink={videoLink}
              setVideoLink={() => {
                setFieldValue('searchVideo', '')
                setFieldValue('video', '')
              }}
              noDeleteDialog={noDeleteDialog}
            />
          ) : (
            <OutlinedAdornment position="end" error={hasVideoError}>
              <TextField
                error={hasVideoError}
                helperText={hasVideoError ? i18n.t('product.validations.video') : ''}
                hiddenLabel
                fullWidth
                value={videoLink}
                name="video"
                onChange={handleChange}
                placeholder={i18n.t('product.videoPlaceholder')}
              />
              <OutlinedAddon position="end" variant="search">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  onClick={searchVideo}
                  disabled={loadingVideo || !videoLink || !isVideoValid}
                >
                  {loadingVideo ? <CircularProgress size={24} color="inherit" /> : <SearchIcon />}
                </Button>
              </OutlinedAddon>
            </OutlinedAdornment>
          )}
        </Grid>
      </Grid>
      <ProductVideoModal
        setLoadingVideo={setLoadingVideo}
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        handleConfirm={() => {
          setFieldValue('video', videoLink)
          setIsModalOpen(false)
          setLoadingVideo(false)
          if (onVideoLoad) {
            onVideoLoad()
          }
        }}
        videoLink={videoLink}
      />
    </Box>
  )
}

export default ProductVideo
